<template>
  <div class="flex items-start">
    <div
      class="min-w-[4em] text-16 font-semibold mr-[23px] whitespace-nowrap p-[3px_0] text-right text-font-1 z-10"
    >
      {{ data?.tag_name }}
    </div>
    <div
      class="flex-y-center flex-wrap gap-[10px_14px] text-14 text-font-60 select-none"
    >
      <TagItem
        v-for="x in dictList"
        :key="x.tag_id"
        :data="x"
        :checks="checks"
        @change="onUpdateData"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import TagItem from './tagItem.vue'
import type { Tag } from '~/api/interface'

const props = defineProps<{
  modelValue?: Tag[]
  multiple?: boolean
  data?: Tag
}>()
const emit = defineEmits(['update:modelValue', 'change'])
const dictList = computed(() => {
  const all: Tag = {
    tag_id: props?.data?.tag_id || -1,
    ids: `${props?.data?.level},${props?.data?.tag_id}`,
    tag_name: $t('quan-bu'),
    level: props?.data?.level || 0,
  }
  return [all, ...(props.data?.children || [])]
})
const { $t } = useNuxtApp()

const resourceLocation = injectResourceLocation()

const onUpdateData = (
  data: Tag | Tag[],
  checked: boolean,
  isRoute: boolean = false
) => {
  let checksArr = checks.value
  const eachArr = Array.isArray(data) ? data : [data]
  if (
    eachArr?.[0]?.tag_name === $t('quan-bu') ||
    checksArr?.[0]?.tag_name === $t('quan-bu') ||
    isRoute ||
    !props.multiple
  ) {
    checksArr = []
  }

  eachArr.forEach((t: Tag) => {
    const index = checksArr.findIndex((c) => c.ids === t.ids)
    if (checked && index === -1) {
      checksArr.push(t)
    }

    if (!checked && index !== -1) {
      checksArr.splice(index, 1)
    }
  })
  if (!checksArr.length) {
    checksArr = [dictList.value[0]]
  }

  checks.value = checksArr

  if (!isRoute) {
    trackEvent(TRACK_EVENT.CLICK_TEMPLATE_CENTER_TAG_FILTER, {
      source: resourceLocation?.source,
      tag_name: props.data?.tag_name,
      tag_id: props.data?.tag_id,
      children_tag_ids: eachArr.map((item) => item.tag_name).join(','),
      children_tag_names: eachArr.map((item) => item.tag_name).join(','),
    })
  }
}

const checks = computed({
  get: () => {
    return props.modelValue || [dictList.value[0]]
  },
  set: (v) => {
    emit('update:modelValue', v)
    emit('change', v)
  },
})
</script>

<style lang="scss" scoped></style>
